import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "document" }
const _hoisted_2 = { class: "document-contents" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "image-area" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "project-title" }
const _hoisted_7 = { class: "state" }
const _hoisted_8 = {
  key: 0,
  class: "no-data"
}
const _hoisted_9 = ["src"]

import { projects } from "../types/apiResponse";
import { APPLICATION_STATE_NAME, BASEURL } from "../consts/common";
import { ProjectStore } from "../store/ProjectStore";
import { ref, onMounted, nextTick } from "vue";
import { CommonStore } from "../store/CommonStore";
import { NO_DATA } from "../consts/common";

export default /*@__PURE__*/_defineComponent({
  __name: 'Document',
  setup(__props) {

const projectStore = ProjectStore();
const commonStore = CommonStore();
const items = ref<projects[]>();
const loading = ref(true);
const infiteScroll = ref(false);
onMounted(async () => {
  if (!projectStore.documentList.length) {
    await projectStore.getDocumentProjects();
  } else {
    nextTick(() => getScrollHeight());
  }
  items.value = projectStore.documentList;
  loading.value = false;
});
const handleScroll = async () => {
  if (loading.value) return;
  const container = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  setScrollHeight();
  if (projectStore.documentAllCalled) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const pageNum = projectStore.documentPageNum + 1;
  projectStore.setDocumentPageNum(pageNum);
  await projectStore.getDocumentProjects();
  infiteScroll.value = true;
  infiteScroll.value = false;
  items.value = projectStore.documentList;
  loading.value = false;
};
const setScrollHeight = () => {
  const item = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  commonStore.setDocumentScrollHeight(item.scrollTop);
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const getScrollHeight = () => {
  const item = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  item.scrollTo({
    top: commonStore.getDocumentScrollHeight,
    behavior: "auto",
  });
};

const linkToDocument = (url: string) => {
  window.open(BASEURL + url);
};
const displayStatus = (state: number) => {
  return APPLICATION_STATE_NAME.find((v) => v.state == state)?.name;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", {
        class: "document-contents-selection",
        onScroll: _cache[0] || (_cache[0] = ($event: any) => (handleScroll()))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (data, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("ul", {
              class: "product-img-wrap",
              onClick: ($event: any) => (linkToDocument(data.document_url))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: data.image
                }, null, 8 /* PROPS */, _hoisted_5),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(data.title), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(displayStatus(data.aplication_state)), 1 /* TEXT */)
                  ])
                ])
              ])
            ], 8 /* PROPS */, _hoisted_3)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _withDirectives(_createElementVNode("div", {
          style: _normalizeStyle(hiddenLoading()),
          class: _normalizeClass([items.value && items.value.length > 0 ? 'loading' : 'first-loading'])
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
        ]), 6 /* CLASS, STYLE */), [
          [_vShow, loading.value]
        ])
      ], 32 /* NEED_HYDRATION */)
    ]),
    (!loading.value && !items.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _unref(NO_DATA).get(5).img
          }, null, 8 /* PROPS */, _hoisted_9)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})